import { MapLike } from '../core'
import { SQSEvent, SQSMessageAttributes, SQSRecord, SQSRecordAttributes } from './aws-lambda-proxy'
import { Message } from '@aws-sdk/client-sqs'

const debug = false

type MessageBodyAttributeMap = Message['MessageAttributes']

export type SQSMessageAttrSource = {
  Action: string | 'EMAIL_REQUEST_NOTIFICATION_SEND' | 'SMS_REQUEST_NOTIFICATION_SEND'
  AppId?: string
}

export type SQSMatchableKeyMessageSource = SQSMessageAttrSource & { MatchDynamicKey: string }

export type ParsableTo<T> = string

export type IOTV_SQSEventRecord<T extends MapLike<string | boolean | number>> = SQSRecord & { body: ParsableTo<T> }

export type IOTV_SQSEvent<T extends MapLike<string | boolean | number>> = SQSEvent & {
  Records: IOTV_SQSEventRecord<T>[]
}

export type SQSUnStringedMessageRequest<T1 extends MapLike<any>, T2 extends MapLike<any>> = {
  MessageBody: T1
  QueueUrl: string
  MessageAttributes: { [k in keyof T2]: string | number | boolean }
} & Pick<SQSRecordAttributes, 'MessageGroupId'>

export const mapToSQSMessageAttributes = (ob: MapLike<string | number | boolean>): MessageBodyAttributeMap => {
  const messageAttributes: MessageBodyAttributeMap = {}
  Object.entries(ob).forEach(([k, v]) => {
    if (typeof v === 'string') {
      messageAttributes[k] = {
        DataType: 'String',
        StringValue: v,
      }
    } else if (typeof v === 'number') {
      messageAttributes[k] = {
        DataType: 'Number',
        StringValue: v.toString(),
      }
    } else if (typeof v === 'boolean') {
      messageAttributes[k] = {
        DataType: 'Boolean',
        StringValue: v.toString(),
      }
    } else {
      debug && console.log(`${k} with value ${v} not supported yet, only doing strings, booleans, numbers`)
    }
  })

  return messageAttributes
}

export const sQSMessageAttributesToMap = (ob: SQSMessageAttributes): MapLike<string | number | boolean> => {
  const map: MapLike<string | number | boolean> = {}
  Object.entries(ob).forEach(([k, v]) => {
    if (v.stringValue) {
      if (v.dataType === 'String') {
        map[k] = v.stringValue
      } else if (v.dataType === 'Number') {
        map[k] = parseFloat(v.stringValue)
      } else if (v.dataType === 'Boolean') {
        map[k] = v.stringValue === 'true'
      } else if (v.dataType) {
        debug && console.log(`${k} with type ${typeof v} value ${v} not supported yet, only doing strings, booleans, numbers`)
      } else {
        debug && console.log(`${k} with type ${typeof v} value ${v} could not be processed`)
      }
    }
  })

  return map
}

export const mapToMOCKEventTriggerSQSMessageAttributes = (ob: MapLike<string | number | boolean>): SQSMessageAttributes => {
  const messageAttributes: SQSMessageAttributes = {}
  Object.entries(ob).forEach(([k, v]) => {
    if (typeof v === 'string') {
      messageAttributes[k] = {
        dataType: 'String',
        stringValue: v,
      }
    } else if (typeof v === 'number') {
      messageAttributes[k] = {
        dataType: 'Number',
        stringValue: v.toString(),
      }
    } else if (typeof v === 'boolean') {
      messageAttributes[k] = {
        dataType: 'Boolean',
        stringValue: v.toString(),
      }
    } else {
      debug && console.log(`${k} with value ${v} not supported yet, only doing strings, booleans, numbers`)
    }
  })

  return messageAttributes
}
